<template>
  <div class="acitvityAll">
    <div class="headReturn">
      <span @click="toSetting">
        <i class="el-icon-arrow-left"></i>
        返回列表
      </span>
      <span style="margin: 0 20px">|</span>
      <span class="name">{{ rowData.activityName }}</span>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="formSty">
      <el-tab-pane label="活动统计" name="first">
        <div class="section-right-content-box">
          <div style="margin: 20px 0px 20px 0px">
            <el-form label-width="10px">
              <el-form-item>
                <span style="margin-right: 20px">统计时间 :</span>
                <el-radio
                  v-model="queryForm.evaluateTime"
                  @change="timeChange"
                  v-for="item in options.evaluateTimeOpt"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}</el-radio
                >
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="postForm.startDate"
                    type="date"
                    :placeholder="'选择日期时间'"
                    size="small"
                    :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 120px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  ></el-date-picker>
                  <div
                    class="time_to_text"
                    :class="{
                      to_text_disabled: queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
                    }"
                  >
                    至
                  </div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="postForm.endDate"
                    type="date"
                    :placeholder="'选择日期时间'"
                    size="small"
                    :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 145px; font-size: 12px"
                    class="time2"
                    :clearable="true"
                  ></el-date-picker>
                  <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
                  <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
                </div>
                <el-button class="b1" style="margin-left: 20px" @click="queryTotal()"
                  ><span style="marginleft: 4px">
                    <i
                      class="el-icon-search"
                      style="
                        display: inline-block;
                        width: 14px;
                        height: 12px;
                        fontweight: bold;
                        margin-right: 4px;
                      "
                    ></i
                    >查询</span
                  ></el-button
                >
                <el-button class="b2" style="margin-left: 20px" @click="queryOne()"><span style="marginleft: 4px">重置</span></el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">数据总览</span>
          </div>
          <div v-loading="loading">
            <div class="overview1" style="float: left">
              <div>
                <span class="fontClass">活动PV</span>
                <el-popover
                  placement="top-start"
                  width="200"
                  offset="100"
                  trigger="hover"
                  content="活动页面访问次数，刷新一次或点击一次都算一次PV流量。"
                >
                  <span style="float: right; margin-top: -10px" slot="reference">
                    <p class="question_icon">?</p>
                  </span>
                </el-popover>
              </div>
              <div class="num">{{ tableTotal.pv }}</div>
            </div>
            <div class="overview1" style="float: left">
              <div>
                <span class="fontClass">活动UV</span>
                <el-popover
                  placement="top-start"
                  width="200"
                  offset="100"
                  trigger="hover"
                  content="活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。"
                >
                  <span style="float: right; margin-top: -10px" slot="reference">
                    <p class="question_icon">?</p>
                  </span>
                </el-popover>
              </div>
              <div class="num">{{ tableTotal.uv }}</div>
            </div>
            <div class="overview1" style="float: left">
              <div>
                <span class="fontClass">参与人数</span>
                <el-popover placement="top-start" width="200" offset="100" trigger="hover" content="参与活动的人数。">
                  <span style="float: right; margin-top: -10px" slot="reference">
                    <p class="question_icon">?</p>
                  </span>
                </el-popover>
              </div>
              <div class="num">{{ tableTotal.joinNumber }}</div>
            </div>
            <div class="overview1" style="float: left">
              <div>
                <span class="fontClass">参与次数</span>
                <el-popover placement="top-start" width="200" offset="100" trigger="hover" content="参与活动的次数。">
                  <span style="float: right; margin-top: -10px" slot="reference">
                    <p class="question_icon">?</p>
                  </span>
                </el-popover>
              </div>
              <div class="num">{{ tableTotal.joinTimes }}</div>
            </div>
            <div class="overview1" style="float: left">
              <div>
                <span class="fontClass">人均参与次数</span>
                <el-popover placement="top-start" width="200" offset="100" trigger="hover" content="参与次数/参与人数。">
                  <span style="float: right; margin-top: -10px" slot="reference">
                    <p class="question_icon">?</p>
                  </span>
                </el-popover>
              </div>
              <div class="num">{{ tableTotal.perJoinNumber }}</div>
            </div>
          </div>
          <div style="clear: left" ref="payRemindChart" class="chart" v-loading="loading"></div>
          <el-table
            :data="activityTable"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; margin: 40px auto"
          >
            <el-table-column prop="statsDate" label="参与时间" width="500"> </el-table-column>
            <el-table-column label="活动参与统计" width="500">
              <template slot-scope="scope">
                <span>参与人数:{{ scope.row.joinNumber }} </span>
                <span>参与人次:{{ scope.row.joinTimes }} </span>
                <span>新增人数:{{ scope.row.incrFollowNumber }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="prizeNum" label="奖品统计">
              <template slot-scope="scope">
                <span v-if="scope.row.aqy != null"> 爱奇艺会员:{{ scope.row.aqy }}个 </span>
                <span v-if="scope.row.beans != null"> 京豆:{{ scope.row.beans }}个 </span>
                <span v-if="scope.row.coupon != null"> 优惠券:{{ scope.row.coupon }}张 </span>
                <span v-if="scope.row.eCard != null"> E卡:{{ scope.row.eCard }}张 </span>
                <span v-if="scope.row.goods != null"> 实物:{{ scope.row.goods }}件 </span>
                <span v-if="scope.row.plus != null"> PLUS会员:{{ scope.row.plus }}个 </span>
                <span v-if="scope.row.redPacket != null"> 红包:{{ scope.row.redPacket }}元 </span>
                <span v-if="scope.row.scores != null"> 积分:{{ scope.row.scores }}积分 </span>
                <!-- <span>参与人次:{{ scope.row.joinTimes }} </span>
                <span>新增人数:{{ scope.row.incrFollowNumber }} </span> -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="text-align: right; margin: 25px"
            @size-change="handleSizeChange"
            background
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            :current-page="1"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <!-- 签到纪录 -->
      <el-tab-pane label="签到记录" name="second" v-if="rowData.activityType == 1">
        <input-form :inputData="inputData" @toParentVal="searchForm" :btnPosition="true" style="margin: 20px 0"></input-form>
        <el-table
          v-loading="loading"
          :data="signInTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="memberNick" label="用户昵称" width="400"> </el-table-column>
          <el-table-column prop="signTime" label="签到时间" width="400"> </el-table-column>
          <el-table-column prop="cumulativeTimes" label="累计签到次数(含历史记录)" width="400"> </el-table-column>
          <el-table-column prop="sequenceTimes" label="连续签到次数(不含历史记录)"> </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeSignIn"
          background
          @current-change="handleCurrentSignIn"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSignIn"
          :current-page="1"
        ></el-pagination>
      </el-tab-pane>
      <!-- 中奖纪录 -->
      <el-tab-pane label="中奖记录" name="third">
        <input-form :inputData="inputAward" @toParentVal="searchAward" :btnPosition="true" style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" @click="exportTheData" v-preventReClick>导出</el-button>
        <el-table
          v-loading="loading"
          :data="awardTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="memberNick" label="用户昵称" width="210"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称"> </el-table-column>
          <el-table-column prop="inviteNick" label="被邀请人昵称" width="150" v-if="rowData.activityType == 5 || rowData.activityType == 6">
          </el-table-column>
          <el-table-column label="奖品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1">优惠券</span>
              <span v-if="scope.row.prizeType == 2">京豆</span>
              <span v-if="scope.row.prizeType == 3">实物</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
              <span v-if="scope.row.prizeType == 5">京豆E卡</span>
              <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
              <span v-if="scope.row.prizeType == 7">京豆PLUS会员</span>
              <span v-if="scope.row.prizeType == 8">现金红包</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" width="210"> </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="150" v-if="rowData.activityType == 5">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <div
                  class="openHover"
                  v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="handleDecrypt('mobile', 'awardTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="参与时间" width="400">
            <template slot-scope="scope">
              <span>{{ scope.row.joinTime }} </span>
            </template>
          </el-table-column>
          <el-table-column label="中奖状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">-</span>
              <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
              <span v-if="scope.row.status == 2"><i class="y2"></i>已中奖</span>
              <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
              <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
              <span v-if="scope.row.status == 5"><i class="y4"></i>已发放</span>
              <span v-if="scope.row.status == 6"><i class="y4"></i>已发放</span>
              <el-tooltip effect="dark" :content="scope.row.failReason" placement="top-start">
                <img v-if="scope.row.status == 4" src="../../assets/images/ask.png" alt="" />
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <el-button type="text" v-if="scope.row.status == 4 || scope.row.status == 2" @click="markIss(scope.row)">标记发放</el-button>
              <el-button type="text" v-if="scope.row.status == 5 || scope.row.status == 6" @click="markIss(scope.row)">取消发放</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeAward"
          background
          @current-change="handleCurrentAward"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalAward"
          :current-page="1"
        ></el-pagination>
      </el-tab-pane>
      <!-- 实物奖品 -->
      <el-tab-pane label="实物奖品名单" name="four" v-if="rowData.activityType == 3 || rowData.activityType == 5 || rowData.activityType == 8">
        <input-form :inputData="inputInkind" @toParentVal="searchInkind" :btnPosition="true" style="margin: 20px 0"></input-form>
        <el-table
          v-loading="loading"
          :data="inkindTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="memberNick" label="用户昵称" width="210"> </el-table-column>
          <el-table-column prop="prizeTitle" label="奖品名称" width="210"> </el-table-column>
          <el-table-column prop="sendTime" label="中奖时间" width="400"> </el-table-column>
          <el-table-column prop="receiverName" label="收件人" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName }}
                <div
                  class="openHover"
                  v-if="scope.row.receiverName && scope.row.receiverName.indexOf('*') != -1"
                  @click="handleDecrypt('receiverName', 'inkindTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverMobile" label="收件人手机号" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile }}
                <div
                  class="openHover"
                  v-if="scope.row.receiverMobile && scope.row.receiverMobile.indexOf('*') != -1"
                  @click="handleDecrypt('receiverMobile', 'inkindTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverAddress" label="收件人地址" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress }}
                <div
                  class="openHover"
                  v-if="scope.row.receiverAddress && scope.row.receiverAddress.indexOf('*') != -1"
                  @click="handleDecrypt('receiverAddress', 'inkindTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverCode" label="邮编"> </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeInkind"
          background
          @current-change="handleCurrentInkind"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalInkind"
          :current-page="1"
        ></el-pagination>
      </el-tab-pane>
      <!-- 资料明细 -->
      <el-tab-pane label="用户资料明细" name="fird" v-if="rowData.activityType == 7">
        <input-form :inputData="inputUserInfo" @toParentVal="searchUserInfo" :btnPosition="true" style="margin: 20px 0"></input-form>
        <el-table
          :data="userInfoTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto"
        >
          <el-table-column prop="memberNick" label="用户昵称" width="150"> </el-table-column>
          <el-table-column prop="name" label="姓名" width="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.name }}
                <div
                  class="openHover"
                  v-if="scope.row.name && scope.row.name.indexOf('*') != -1"
                  @click="handleDecrypt('name', 'userInfoTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <div
                  class="openHover"
                  v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="handleDecrypt('mobile', 'userInfoTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="birthDay" label="生日" width="200">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.birthDay }}
                <div
                  class="openHover"
                  v-if="scope.row.birthDay && scope.row.birthDay.indexOf('*') != -1"
                  @click="handleDecrypt('birthDay', 'userInfoTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="qq" label="QQ" width="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.qq }}
                <div
                  class="openHover"
                  v-if="scope.row.qq && scope.row.qq.indexOf('*') != -1"
                  @click="handleDecrypt('qq', 'userInfoTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="weChat" label="微信" width="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.weChat }}
                <div
                  class="openHover"
                  v-if="scope.row.weChat && scope.row.weChat.indexOf('*') != -1"
                  @click="handleDecrypt('weChat', 'userInfoTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="性别" width="150">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.sex == 0">未知</span>
              <span v-if="scope.row.sex == 1">男</span>
              <span v-if="scope.row.sex == 2">女</span> -->
              <div class="open">
                <span v-if="scope.row.sex.indexOf('*') != -1">{{ scope.row.sex }}</span>
                <span v-if="scope.row.sex == 0">未知</span>
                <span v-if="scope.row.sex == 1">男</span>
                <span v-if="scope.row.sex == 2">女</span>
                <div
                  class="openHover"
                  v-if="scope.row.sex && scope.row.sex.indexOf('*') != -1"
                  @click="handleDecrypt('sex', 'userInfoTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="job" label="职业" width="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.job }}
                <div
                  class="openHover"
                  v-if="scope.row.job && scope.row.job.indexOf('*') != -1"
                  @click="handleDecrypt('job', 'userInfoTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="地址" width="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.address }}
                <div
                  class="openHover"
                  v-if="scope.row.address && scope.row.address.indexOf('*') != -1"
                  @click="handleDecrypt('address', 'userInfoTable', scope.row, scope.$index)"
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="扩展信息" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.extendInfo | showextendInfo }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 25px"
          @size-change="handleSizeUserInfo"
          background
          @current-change="handleCurrentUserInfo"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalUserInfo"
          :current-page="1"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import echarts from "echarts";
import inputForm from "../../components/inputForm";
import {
  checkRecord,
  getCouponData,
  getCouponTable,
  checkList,
  awardRecord,
  awardRecNew,
  inKindList,
  exportRecord,
  exportRecNew,
  // getGoodRecords,
  improveList,
  signIssuance,
} from "@/api/integralCenter/PointActivityAnalyticController";
export default {
  components: {
    inputForm,
  },
  props: {
    rowData: {
      type: Object,
    },
    ids1: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      activeName: "first",
      activityTable: [],
      signInTable: [],
      awardTable: [],
      inkindTable: [],
      userInfoTable: [],
      queryForm: {
        evaluateTime: "7",
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      tableTotal: {
        pv: 0, //会员中心首页PV
        uv: 0, //会员中心首页uv
        // incrJoinNumber: [], //参与人数今日增量
        joinNumber: 0, //参与人数
        joinTimes: 0, //参与人次
        perJoinNumber: 0, //人均参与次数
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //折线图数据
      myCharts: null,
      chartEffectDetail: {
        pv: [], //会员中心首页PV
        uv: [], //会员中心首页uv
        joinNumber: [], //参与人数
        joinTimes: [], //参与人次
        perJoinNumber: [], //人均参与次数
        statsDate: [], // 统计日期
      },
      totalNum: 0,
      totalAward: 0,
      totalSignIn: 0,
      totalInkind: 0,
      totalUserInfo: 0,
      formList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      inputData: [
        {
          name: "用户pin:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "签到时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAward: [
        {
          name: "用户pin:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "京东E卡", id: 5 },
            { label: "爱奇艺会员", id: 6 },
            { label: "PLUS会员", id: 7 },
            { label: "现金红包", id: 8 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputInkind: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputUserInfo: [
        {
          name: "时间范围:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
    };
  },
  filters: {
    showextendInfo(obj) {
      let obj1 = JSON.parse(obj);
      let string = "";
      for (const key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          let key1 = key;
          let val = obj1[key];
          string += key1 + ":" + val + "; ";
        }
      }

      return string;
    },
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  created() {
    this.timeChange();
    this.queryTotal();
    console.log(this.rowData);
    // this.aaa()
  },
  mounted() {
    console.log(this.rowData);
    this.initChart(); //折线图
    // this.checkRecord();//签到纪录
    this.winningRecord(); //中奖纪录
    // this.inKingRecord();//实物奖品
    // this.improveRecord();//资料明细
    if (this.rowData.activityType == 1) {
      this.checkRecord(); //签到纪录
    }
    if (this.rowData.activityType == 7) {
      this.improveRecord(); //资料明细
    }
    if (this.rowData.activityType == 3 || this.rowData.activityType == 8) {
      this.inKingRecord(); //实物奖品
    }
  },
  methods: {
    // aaa(){
    //   console.log(this.ids1);
    // },
    //返回列表
    toSetting() {
      this.$emit("returnStep");
    },
    //页头点击
    handleClick(tab, event) {
      console.log(tab.index == 2);
      if (tab.index == 2) {
        console.log(this.formList);
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.inKingRecord();
      }
    },
    timeChange(type) {
      let self = this;
      let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      let tt = "00:00:00";
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      if (type == null) {
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else if (type == 7) {
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    //查询数据总和
    queryTotal() {
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "";
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      getCouponData({
        activityId: this.formList.activityId,
        startTime,
        endTime,
      })
        .then((res) => {
          this.loading = false;
          this.tableTotal = res.data;
          // console.log(this.postForm.endDate);
        })
        .catch((res) => {
          // this.$message.error("输入时间错误");
        });

      //折线图数据查询
      checkRecord({
        activityId: this.formList.activityId,
        startTime,
        endTime,
      })
        .then((res) => {
          if (res.data.length == 1 && res.data.length == 0) {
            this.$message.error("折线图时间过短");
          } else if (res.data.length > 1) {
            var dataList = res.data;
            console.log(dataList);
            var homePagePvList = []; //会员中心首页PV
            var homePageUvList = []; //会员中心首页uv
            // var incrJoinNumberList = []; //参与人数今日增量
            var joinNumberList = []; //参与人数
            var joinTimesList = []; //参与人次
            var perCapitaTimesList = []; //人均参与次数
            // var pvList = []; //页面浏览数
            var statsDateList = []; // 统计日期
            // var uvList = []; //页面访问人数
            dataList.forEach((item) => {
              homePagePvList.push(item.pv);
              homePageUvList.push(item.uv);
              // incrJoinNumberList.push(item.incrJoinNumber);
              joinNumberList.push(item.joinNumber);
              joinTimesList.push(item.joinTimes);
              perCapitaTimesList.push(item.perJoinNumber);
              // pvList.push(item.pv);
              statsDateList.push(item.statsDate);
              // uvList.push(item.uv);
            });
            this.chartEffectDetail = {
              pv: homePagePvList, //会员中心首页PV
              uv: homePageUvList, //会员中心首页uv
              // incrJoinNumber: incrJoinNumberList, //参与人数今日增量
              joinNumber: joinNumberList, //参与人数
              joinTimes: joinTimesList, //参与人次
              perJoinNumber: perCapitaTimesList, //人均参与次数
              // pv: pvList, //页面浏览数
              statsDate: statsDateList, // 统计日期
              // uv: uvList, //页面访问人数
            };
          }
          this.$nextTick(() => {
            this.initChart();
            window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
        })
        .catch((res) => {
          // this.$message.error("输入时间错误");
        });

      //列表数据查询
      getCouponTable({
        activityId: this.formList.activityId,
        size: this.formList.size,
        current: this.formList.current,
        startTime,
        endTime,
      })
        .then((res) => {
          this.loading = false;
          this.activityTable = res.data.records;
          this.totalNum = Number(res.data.total);
          // console.log(this.postForm.endDate);
        })
        .catch((res) => {
          // this.$message.error("输入时间错误1");
        });
    },
    // //实物奖品名单
    // getGoodRecords1(){
    //   this.loading = true;
    //   inKindList(this.formList)
    //     .then((res) => {
    //       this.loading = false;
    //       this.inkindTable = res.data.records;
    //       // console.log(res.data.records);
    //       this.totalSignIn = Number(res.data.total);
    //     })
    //     .catch((res) => {});
    // },
    // getGoodRecords({
    // }){

    // },

    //折线图
    initChart() {
      this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions(this.chartEffectDetail);
      // console.log(this.chartEffectDetail);
    },
    //折线图事件
    setOptions({ pv, uv, joinNumber, joinTimes, perJoinNumber, statsDate } = {}) {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["活动PV", "活动UV", "参与人数", "参与次数", "人均参与次数"],
          bottom: -5,
          left: 60,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: statsDate,
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            name: "活动PV",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#7F85E9",
            data: pv,
          },
          {
            name: "活动UV",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#5882FB",
            data: uv,
          },
          {
            name: "参与人数",
            type: "line",
            color: "#FE4D45",
            areaStyle: {},
            smooth: true,
            data: joinNumber,
          },
          {
            name: "参与次数",
            type: "line",
            color: "#FFC400",
            areaStyle: {},
            smooth: true,
            data: joinTimes,
          },
          {
            name: "人均参与次数",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#FF938E",
            data: perJoinNumber,
          },
        ],
      };

      this.myCharts.setOption(option);
    },
    //重置
    queryOne() {
      this.queryForm.evaluateTime = "7";
      this.timeChange(7);
      this.queryTotal();
    },
    //签到记录
    checkRecord() {
      this.loading = true;
      checkList(this.formList)
        .then((res) => {
          this.loading = false;
          this.signInTable = res.data.records;
          this.totalSignIn = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //中奖记录
    winningRecord() {
      this.loading = true;
      if (this.rowData.activityType == 5 || this.rowData.activityType == 6) {
        awardRecNew(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      } else {
        awardRecord(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      }
    },
    //导出
    exportTheData() {
      if (this.rowData.activityType == 5 || this.rowData.activityType == 6) {
        let param = this.formList.activityId;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/jd-point-web/PointActivityEffectDetails/exportPointInviteActivityPrize?activityId=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);

        // exportRecNew({activityId:param}).then((res) => {});
      } else {
        let param = this.formList.activityId;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/jd-point-web/PointActivityEffectDetails/exportPointActivityPrizeDetail?activityId=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    },
    //实物奖品
    inKingRecord() {
      this.loading = true;
      console.log(this.formList);
      inKindList(this.formList)
        .then((res) => {
          this.loading = false;
          // this.userInfoTable = res.data.records;
          this.totalInkind = Number(res.data.total);
          this.inkindTable = res.data.records;
          // // console.log(res.data.records);
          // this.totalSignIn = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //资料明细
    improveRecord() {
      this.loading = true;
      this.formList.startTime = "2010-01-01 00:00:00";
      this.formList.endTime = "2030-01-01 00:00:00";
      improveList(this.formList)
        .then((res) => {
          this.loading = false;
          this.userInfoTable = res.data.records;
          this.totalUserInfo = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //标记状态
    markIss(row) {
      signIssuance({ id: row.id })
        .then((res) => {
          if (res && res.code == 1) {
            this.winningRecord();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.queryTotal();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.queryTotal();
    },
    handleSizeSignIn(val) {
      this.formList.size = val;
      this.checkRecord();
    },
    handleCurrentSignIn(val) {
      this.formList.current = val;
      this.checkRecord();
    },
    handleSizeAward(val) {
      this.formList.size = val;
      this.winningRecord();
    },
    handleCurrentAward(val) {
      this.formList.current = val;
      this.winningRecord();
    },
    handleSizeInkind(val) {
      this.formList.size = val;
      this.inKingRecord();
    },
    handleCurrentInkind(val) {
      this.formList.current = val;
      this.inKingRecord();
    },
    handleSizeUserInfo(val) {
      this.formList.size = val;
      this.improveRecord();
    },
    handleCurrentUserInfo(val) {
      this.formList.current = val;
      this.improveRecord();
    },
    //签到查询
    searchForm(val) {
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.checkRecord();
    },
    searchAward(val) {
      this.current = 1;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.winningRecord();
    },
    searchInkind(val) {
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.inKingRecord();
      // this.getGoodRecords1();
    },
    searchUserInfo(val) {
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.improveRecord();
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index) {
      let params = "";
      // 资料明细 userInfoTable  实物奖品 inkindTable
      if (objdata == "userInfoTable") {
        params = "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "inkindTable") {
        params = "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      }
      // console.log(params);
      this.$decrypt.decrypt({ decryptContent: item[`${params}`] }).then((res) => {
        this[`${objdata}`][index][`${name}`] = res.message;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.acitvityAll {
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      cursor: default;
    }
  }
  .formSty {
    margin: 35px;
    .question_icon {
      width: 15px;
      height: 15px;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #ccc;
      font-size: 14px !important;
      font-weight: normal !important;
      margin-left: 4px;
    }
    .y1,
    .y2,
    .y3,
    .y4 {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .y1 {
      background-color: #cccccc;
    }
    .y2 {
      background-color: #7f85e9;
    }
    .y3 {
      background-color: #fe4d45;
    }
    .y4 {
      background-color: #49c568;
    }
    .section-right-content-box {
      // min-width: 1000px;
      // border-bottom: 6px;
      // padding: 15px 28px 30px 28px;
      // background: rgba(255, 255, 255, 1);
      // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      // opacity: 1;
      // -webkit-box-sizing: border-box;
      // -moz-box-sizing: border-box;
      // box-sizing: border-box;
      // margin: 0 20px 20px 20px;
      .tabList {
        display: flex;
        box-sizing: border-box;
        height: 36px;
        line-height: 35px;
        // margin-top: 20px;
        color: #666;
        font-size: 14px;
        margin: 20px 0;
        span {
          margin-right: 3px;
          width: 106px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          vertical-align: middle;
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          border-radius: 2px 2px 0px 0px;
          border: 1px solid #dddddd;
          text-align: center;
        }
        .active {
          position: relative;
          transition: all 0.2s;
          color: #fe4d45;
          border-bottom: none;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            top: 0;
            height: 2px;
            background: #fe4d45;
            border-radius: 6px 6px 0px 0px;
          }
        }
        i {
          flex: 1;
          border-bottom: 1px solid #dddddd;
          margin-left: -3px;
        }
      }
      .b1 {
        width: 98px;
        height: 32px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }
      .b2 {
        width: 98px;
        height: 32px;
        color: #666666;
        border: 1px solid #dddddd;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
      .background {
        height: 32px;
        background: rgba(250, 250, 250, 1);
        opacity: 1;
        line-height: 32px;
        padding-left: 12px;
        .title {
          display: inline-block;
          width: 2px;
          height: 14px;
          background: rgba(254, 77, 69, 1);
          opacity: 1;
          border-radius: 3px;
          vertical-align: middle;
        }
        .tips {
          width: 56px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
          vertical-align: middle;
        }
      }

      .overview1 {
        padding: 26px 30px 22px 30px;
        width: 20%;
        height: 100px;
        border-right: 1px solid #f3f3f3;
        opacity: 1;
        margin: 20px 0px;
        .fontClass {
          width: 102px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          opacity: 1;
        }
        .question_icon {
          width: 14px;
          height: 14px;
          color: #cccccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #cccccc;
          font-size: 12px;
          font-weight: normal;
        }
        .num {
          width: 65px;
          height: 29px;
          font-size: 24px;
          font-family: DIN;
          font-weight: bold;
          line-height: 29px;
          color: rgba(254, 77, 69, 1);
          opacity: 1;
          margin-top: 14px;
          margin-bottom: 30px;
        }
      }
      .chart {
        // flex: 1;
        height: 380px;
        min-width: 1100px;
      }
    }
  }
}
</style>
